import React from 'react';

interface IProps {
  className?: string;
  label: string;
  onClick: (e: React.MouseEvent) => void;
  title?: string | undefined;
}

export const ZeosActionButton = (props: IProps) => {
  return (
    <button
      className={`pointer-events-auto rounded-md border border-gray-300 bg-white/90 px-2 py-1 text-xs text-gray-700 shadow-sm hover:bg-white ${
        props.className || ""
      }`}
      onClick={props.onClick}
      title={props.title}
      type="button"
    >
      {props.label}
    </button>
  );
};
